import axios from 'axios';
import authHeader from "@/service/auth-header";

class NoteService {

    async getCompanyNotes(companyId) {
        return await axios.get(`/api/note1/${companyId}`, {headers: authHeader()})
    }

    async getClientNotes(clientId) {
        return await axios.get(`/api/note1/client/${clientId}`, {headers: authHeader()})
    }

    async createClientNote(clientId, data) {
      return await axios.post(`/api/note1/client/${clientId}`, data,{ headers: authHeader() });
    }

    async updateClientNote(clientId, data) {
        return await axios.put(`/api/note1/client/${clientId}`, data,{ headers: authHeader() });
    }

    async deleteNote(noteId) {
        return await axios.delete(`/api/note1/${noteId}`,{ headers: authHeader() })
    }

    async createClientNoteWithTemplate(clientId, noteTemplateId) {
        return await axios.post(`/api/note1/client/${clientId}/${noteTemplateId}`, null,{ headers: authHeader() });
    }

}

export default new NoteService();
